import { render, staticRenderFns } from "./RelaisNewEdit.vue?vue&type=template&id=e1418ab2&scoped=true&"
import script from "./RelaisNewEdit.vue?vue&type=script&lang=js&"
export * from "./RelaisNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1418ab2",
  null
  
)

export default component.exports